export const PAYMENT_METHODS = {
  CREDIT_CARD: "CREDIT_CARD",
  DEBIT_CARD: "DEBIT_CARD",
  MERCADO_PAGO: "MERCADO_PAGO",
  CASH: "CASH",
};

export const PAYMENT_METHODS_CHOICES_FOR_PURCHASE = [
  { id: PAYMENT_METHODS.CREDIT_CARD, name: "Tarjeta de Crédito" },
  { id: PAYMENT_METHODS.DEBIT_CARD, name: "Tarjeta de Débito" },
  { id: PAYMENT_METHODS.MERCADO_PAGO, name: "Mercado Pago" },
];

export const PAYMENT_METHODS_CHOICES_FOR_COUPON = [
  ...PAYMENT_METHODS_CHOICES_FOR_PURCHASE,
  { id: PAYMENT_METHODS.CASH, name: "Efectivo" },
];
